import type { PathType } from './types';
import { getPath } from './types';

export const hrTicketPaths: { [key: string]: PathType } = {
  // Biometric related
  // biometricLog: getPath('/system-admin/biometric-log', [
  //   'sidebar.hr.biometric.index',
  //   'sidebar.hr.biometricLog'
  // ]),
  biometricEmployeeMapping: getPath('/system-admin/biometric-employee-mapping', [
    'sidebar.hr.biometric.index',
    'sidebar.hr.biometricEmployeeMapping'
  ]),
  biometricDevice: getPath('/system-admin/biometric-device', [
    'sidebar.hr.biometric.index',
    'sidebar.master-data.biometricDevice'
  ]),
  biometricDeviceDownloadLog: getPath('/system-admin/biometric-device-download-log', [
    'sidebar.hr.biometric.index',
    'sidebar.hr.biometricDeviceDownloadLog'
  ]),
  biometricLog: getPath('/biometric-log', ['v2.sidebar.home', 'v2.sidebar.hrTicket.biometricLog']),
  biometricLogSub: getPath('/s/biometric-log', ['v2.sidebar.home', 'v2.sidebar.hrTicket.biometricLog']),

  // HR general
  advancePaymentLimit: getPath('/system-admin/advance-payment-limit', [
    'v2.sidebar.home',
    'sidebar.hr.index',
    'sidebar.hr.advancePaymentLimit'
  ]),
  employeeEvaluation: getPath('/system-admin/employee-evaluation', [
    'v2.sidebar.home',
    'sidebar.hr.index',
    'sidebar.hr.employeeEvaluation'
  ]),
  leaveRemainingYear: getPath('/system-admin/leave-remaining-year', ['sidebar.home', 'v2.leaveRemainingYear.index']),
  employeeShift: getPath('/system-admin/employee-shift', ['sidebar.home', 'v2.employeeShift.index']),
  advancePaymentEmployee: getPath('/system-admin/advance-payment-employee', [
    'sidebar.home',
    'v2.advancePaymentEmployee.index'
  ]),
  leaveTicketPackage: getPath('/system-admin/leave-ticket-package', ['sidebar.home', 'v2.leaveTicketPackage.index']),
  leaveTicketPackageAdd: getPath('/system-admin/leave-ticket-package/add', [
    'sidebar.home',
    'v2.leaveTicketPackage.index',
    'action.add'
  ]),
  leaveTicketPackageDetail: getPath('/system-admin/leave-ticket-package/detail', [
    'sidebar.home',
    'v2.leaveTicketPackage.index',
    'page.detail'
  ]),
  additionalWorkingTimePackage: getPath('/system-admin/additional-working-time-package', [
    'sidebar.home',
    'v2.additionalWorkingTimePackage.index'
  ]),
  additionalWorkingTimePackageAdd: getPath('/system-admin/additional-working-time-package/add', [
    'sidebar.home',
    'v2.additionalWorkingTimePackage.index',
    'action.add'
  ]),
  additionalWorkingTimePackageDetail: getPath('/system-admin/additional-working-time-package/detail', [
    'sidebar.home',
    'v2.additionalWorkingTimePackage.index',
    'page.detail'
  ]),
  additionalWage: getPath('/system-admin/additional-wage', ['sidebar.home', 'v2.additionalWage.index']),
  employeeCompensation: getPath('/system-admin/employee-compensation', [
    'sidebar.home',
    'v2.employeeCompensation.index'
  ]),
  timesheet: getPath('/system-admin/timesheet', ['sidebar.home', 'sidebar.hr.timesheet']),
  timesheetAdd: getPath('/system-admin/timesheet/add', ['sidebar.home', 'v2.timesheet.index', 'action.add']),
  timesheetDetail: getPath('/system-admin/timesheet/detail', ['sidebar.home', 'v2.timesheet.index', 'page.detail'])
};
